import { render, staticRenderFns } from "./ApplicationReviewSection.vue?vue&type=template&id=9665b490&scoped=true&"
import script from "./ApplicationReviewSection.vue?vue&type=script&lang=js&"
export * from "./ApplicationReviewSection.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationReviewSection.vue?vue&type=style&index=0&id=9665b490&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9665b490",
  null
  
)

export default component.exports